import React, { useState } from 'react';
import WeeManage from './CropManage/WeeManage';
import OfcManage from './CropManage/OfcManage';
import VegetableManage from './CropManage/VegetableManage';
import FruitManage from './CropManage/FruitManage';
import RootsManage from './CropManage/RootsManage';

export default function CropsManage({ onSubmitting }) {
    const [selectedCrop, setSelectedCrop] = useState(() => localStorage.getItem('admin_selected_crop') || null);

    const handleCropSelect = (cropId) => {
        setSelectedCrop(cropId);
        if (cropId) {
            localStorage.setItem('admin_selected_crop', cropId);
        } else {
            localStorage.removeItem('admin_selected_crop');
        }
    };

    const categories = [
        { id: 'paddy', title: 'වී වගාව (Paddy)', icon: '🌾' },
        { id: 'vegetables', title: 'එළවළු වගාව (Vegetables)', icon: '🥦' },
        { id: 'fruits', title: 'පලතුරු වගාව (Fruits)', icon: '🍎' },
        { id: 'ofc', title: 'අතිරේක ආහාර බෝග (OFC)', icon: '🌽' },
        { id: 'roots', title: 'අල බෝග (Roots)', icon: '🥔' }
    ];

    const renderCropManager = () => {
        switch (selectedCrop) {
            case 'paddy': return <WeeManage onSubmitting={onSubmitting} />;
            case 'ofc': return <OfcManage onSubmitting={onSubmitting} />;
            case 'vegetables': return <VegetableManage onSubmitting={onSubmitting} />;
            case 'fruits': return <FruitManage onSubmitting={onSubmitting} />;
            case 'roots': return <RootsManage onSubmitting={onSubmitting} />;
            default: return null;
        }
    };

    if (selectedCrop) {
        return (
            <div className="sub-manager-wrapper">
                <style>{`
                    .back-btn {
                        padding: 10px 20px;
                        background: #f3f4f6;
                        border: 1px solid #e5e7eb;
                        borderRadius: 8px;
                        cursor: pointer;
                        margin: 20px;
                        font-weight: 600;
                        color: #374151;
                        transition: all 0.2s;
                        display: flex;
                        align-items: center;
                        gap: 8px;
                    }
                    .back-btn:hover {
                        background: #e5e7eb;
                        transform: translateX(-5px);
                    }
                `}</style>
                <button
                    onClick={() => handleCropSelect(null)}
                    className="back-btn"
                >
                    ← Back to Crop Selection
                </button>
                {renderCropManager()}
            </div>
        );
    }

    return (
        <div className="crops-selection-container">
            {/* ... styles omitted for brevity ... */}
            <style>{`
                .crops-selection-container {
                    padding: 20px;
                    max-width: 1200px;
                    margin: 0 auto;
                }
                
                .crops-header {
                    margin-bottom: 40px;
                    text-align: center;
                }

                .crops-header h2 {
                    font-size: clamp(1.8rem, 5vw, 2.5rem);
                    color: #1a3353;
                    font-weight: 800;
                    margin-bottom: 10px;
                }

                .crops-header p {
                    color: #6b7280;
                    font-size: clamp(0.9rem, 3vw, 1.1rem);
                }

                .crops-admin-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
                    gap: 24px;
                }

                .crop-admin-card {
                    background: #fff;
                    border-radius: 24px;
                    padding: 30px;
                    text-align: center;
                    cursor: pointer;
                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                    border: 1px solid rgba(0,0,0,0.05);
                    box-shadow: 0 4px 15px rgba(0,0,0,0.03);
                }

                .crop-admin-card:hover {
                    transform: translateY(-10px);
                    box-shadow: 0 20px 40px rgba(11, 107, 47, 0.1);
                    border-color: #10b981;
                }

                @media (max-width: 640px) {
                    .crops-selection-container {
                        padding: 15px;
                    }
                    .crops-admin-grid {
                        grid-template-columns: 1fr;
                        gap: 16px;
                    }
                    .crop-admin-card {
                        padding: 20px !important;
                    }
                }
            `}</style>

            <header className="crops-header">
                <h2>බෝග කළමනාකරණය</h2>
                <p>තොරතුරු යාවත්කාලීන කිරීමට අවශ්‍ය බෝග වර්ගය තෝරන්න</p>
            </header>

            <div className="crops-admin-grid">
                {categories.map((cat) => (
                    <div
                        key={cat.id}
                        onClick={() => handleCropSelect(cat.id)}
                        className="crop-admin-card"
                    >
                        <div style={{ fontSize: '3.5rem', marginBottom: '15px' }}>{cat.icon}</div>
                        <h3 style={{ margin: '0 0 10px 0', color: '#111827', fontSize: '1.25rem' }}>{cat.title}</h3>
                        <p style={{ fontSize: '0.85rem', color: '#6b7280', margin: 0 }}>දත්ත ඇතුළත් කිරීම සහ සංස්කරණය</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
